@if (model?.top?.length || model?.flop?.length) {
  <div class="row" id="topflop-list">
    <div class="col-12 mb-2">
      <div class="tile">
        <div class="row">
          <div class="col-12">
            <h3 class="font-medium">{{ 'instrument-detail.instrument-topflop-list.title' | transloco }}</h3>
          </div>
        </div>
        <table class="table-depot table-depot" aria-describedby="topflop-list">
          <thead>
            <tr>
              <th colspan="2">
                {{ 'instrument-detail.instrument-topflop-list.table-head.name' | transloco }}<br />{{
                  'instrument-detail.instrument-topflop-list.table-head.isin' | transloco
                }}
              </th>
              <th>{{ 'instrument-detail.instrument-topflop-list.table-head.quote' | transloco }}</th>
              <th>
                {{ 'instrument-detail.instrument-topflop-list.table-head.perfPct' | transloco }}<br />{{
                  'instrument-detail.instrument-topflop-list.table-head.perfAbs' | transloco
                }}
              </th>
              <th>
                {{ 'instrument-detail.instrument-topflop-list.table-head.quoteTime' | transloco }}<br />{{
                  'instrument-detail.instrument-topflop-list.table-head.quoteDate' | transloco
                }}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (model?.top; as tops) {
              @if (model?.flop?.length) {
                <tr class="group-header" data-zid="header-top">
                  <td class="font-medium no-default-padding" colspan="6">
                    {{ 'instrument-detail.instrument-topflop-list.table-group-label.top' | transloco }}
                  </td>
                </tr>
              }
              @for (topItem of tops; track topItem.isin) {
                <tr topflop-list-item [item]="topItem"></tr>
              }
            }
            @if (model?.flop; as flops) {
              <tr class="group-header" data-zid="header-flop">
                <td class="font-medium no-default-padding" colspan="6">
                  {{ 'instrument-detail.instrument-topflop-list.table-group-label.flop' | transloco }}
                </td>
              </tr>
              @for (flopItem of flops; track flopItem.isin) {
                <tr topflop-list-item [item]="flopItem"></tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
